import { render, staticRenderFns } from "./PanelCompetition.vue?vue&type=template&id=7ddaf06a&scoped=true&"
import script from "./PanelCompetition.vue?vue&type=script&lang=js&"
export * from "./PanelCompetition.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetition.vue?vue&type=style&index=0&id=7ddaf06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddaf06a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ddaf06a')) {
      api.createRecord('7ddaf06a', component.options)
    } else {
      api.reload('7ddaf06a', component.options)
    }
    module.hot.accept("./PanelCompetition.vue?vue&type=template&id=7ddaf06a&scoped=true&", function () {
      api.rerender('7ddaf06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetition.vue"
export default component.exports